// Whether an account's panel offers an address field, and whether that address is
// something Gundi actually needs. base_url lives on the integration record rather
// than in an action configuration, so this is the one place that decides.

import { baseUrlIsRequired } from 'components/routes/providerBaseUrl';

export type BaseUrlPolicy = {
  // Does the panel show an Endpoint section at all?
  show: boolean;
  // Is it allowed to be empty? Drives the " *" on the label and the "needs setup"
  // badge on the section.
  optional: boolean;
};

export function baseUrlPolicy(input: {
  isProvider: boolean;
  techName?: string;
  techValue?: string;
  actions?: any[];
}): BaseUrlPolicy {
  // Only the technologies Gundi is reached at a user-supplied address get this
  // field, whichever side of the Route the account sits on. Every other
  // connector knows its own endpoint — and several ask for one in their auth
  // configuration, so a record-level box here was a second, competing field
  // that could quietly disagree with the one actually in use.
  const required = baseUrlIsRequired(input.techValue);
  return { show: required, optional: !required };
}
